// MF-67 — A titled group of fields inside a FormCard (e.g. "Defaults", "Fields", "Visibility"),
// separated from the previous group by a hairline so long forms read as clear blocks.
import { Typography } from '@mui/material'

const FormSection = ({ title, description, action, children, first = false }) => (
  <div
    className='flex flex-col'
    style={{ gap: 20, ...(first ? {} : { borderTop: '1px solid rgb(241, 245, 249)', paddingTop: 24 }) }}
  >
    {title ? (
      <div className='flex items-start justify-between' style={{ gap: 12 }}>
        <div className='flex flex-col' style={{ gap: 2 }}>
          <Typography style={{ fontSize: 14, fontWeight: 600, color: 'rgb(15, 23, 42)' }}>{title}</Typography>
          {description ? (
            <Typography style={{ fontSize: 13, color: 'rgb(100, 116, 139)' }}>{description}</Typography>
          ) : null}
        </div>
        {action}
      </div>
    ) : null}
    {children}
  </div>
)

export default FormSection
